<footer class="footer footer-dark-blue">
  <div class="container-fluid">
      <div class="row">
          <div class="col-12">
              <div class="wrap-widget">
                  <img src="images/logo-blanco.png" alt="Logotipo de Profejobs" class="main-logo" />
              </div>
          </div>
      </div>
  </div>
  <hr />
  <div class="container-fluid">
      <div class="row">
          <div class="col-md-4">
              <div class="wrap-widget">
                  <h4 class="footer-heading footer-heading-4">Accesos rápidos</h4>
                  <ul class="footer-link-list">
                      <li>
                          <a [routerLink]="'/'+[constantsService.BASE_PATH_FAQ]" target="_self">Preguntas
                              frecuentes</a>
                      </li>
                  </ul>
              </div>
          </div>
          <div class="col-md-4">
              <div class="wrap-widget">
                  <h4 class="footer-heading footer-heading-4">Registros y accesos</h4>
                  <ul class="footer-link-list">
                      <li>
                          <a [routerLink]="[constantsService.BASE_PATH_EMPLOYER]" target="_self">Registro
                              Instituciones</a>
                      </li>
                      <li>
                          <a [routerLink]="[constantsService.BASE_PATH_EMPLOYEE_BASIC]" target="_self">Registo
                              profesores</a>
                      </li>
                      <li>
                          <a [routerLink]="[constantsService.BASE_PATH_LOGIN_EMPLOYER]" target="_self">Ingreso
                              Instituciones</a>
                      </li>
                      <li>
                          <a [routerLink]="[constantsService.BASE_PATH_LOGIN_EMPLOYEE]" target="_self">Ingreso
                              profesores</a>
                      </li>
                  </ul>
              </div>
          </div>
          <div class="col-md-4">
              <div class="wrap-widget">
                  <h4 class="footer-heading footer-heading-4">Redes de contacto</h4>
                  <div class="social-btn-group">
                      <a class="social-btn" href="https://www.facebook.com/ProfeJOBS-101431195148330" target="_blank"
                          title="Facebook ProfeJOBS"><i class="pj-ico pj-ico-220 pj-ico-facebook"></i></a>
                      <a class="social-btn" href="https://www.linkedin.com/company/profejobs/?viewAsMember=true"
                          target="_blank" title="Linkedin ProfeJOBS"><i
                              class="pj-ico pj-ico-220 pj-ico-linkedin"></i></a>
                      <a class="social-btn" href="https://www.instagram.com/profejobs.cl/?hl=es-la" target="_blank"
                          title="Instagram ProfeJOBS"><i class="pj-ico pj-ico-220 pj-ico-footer-instagram"></i></a>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <hr />
  <div class="container-fluid">
      <div class="row">
          <div class="col-12">
              <div class="text-center wrap-widget">
                  <p class="copyright-text">® 2020 ProfeJOBS. Todos los derechos reservados.</p>
              </div>
          </div>
      </div>
  </div>
</footer>